export const minecraft1204 = {
  version: '1.20.4',
  title: 'Bats and Pots',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/game-updates/Bats-and-Pots_01_Header_1170x500%20.jpg',
  releases: [
    {
      id: "1B4DY6fn",
      version: "1.0.4",
      date: "May 10, 2025",
      changelog: "Versión estable para Minecraft 1.20.4",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.20.4",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project/files/7418393",
      isBeta: false
    }
  ]
};
